<template>
  <router-view></router-view>
</template>

<script>
export default {
    name: "ar-wrapper"
};
</script>

<style>
</style>